
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reschedule-appointment",
      function () {
        return require("private-next-pages/reschedule-appointment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reschedule-appointment"])
      });
    }
  